<template>
  <PanelTemplate ref="panel">
    <TabsTemplate ref="tabs" :tabs="aiPanelTabs" @onCloseButtonClicked="hide()"></TabsTemplate>
  </PanelTemplate>
</template>

<script>
import { markRaw } from 'vue'
import PanelTemplate from '@/components-v2/presentation-editor/right-panel-container/PanelTemplate.vue'
import TabsTemplate from '@/components/UI/TabsTemplate.vue'
import AIController from '@/components-v2/presentation-editor/side-right/right-nav/AIController.vue'

export default {
  components: {
    PanelTemplate,
    TabsTemplate,
  },

  computed: {
    aiPanelTabs() {
      return [{
        name: 'Edit with AI',
        component: markRaw(AIController),
      }]
    },
  },

  methods: {
    show(tabIndex) {
      this.$refs.panel.show()
      this.selectTab(tabIndex)
    },

    hide() {
      this.$refs.panel.hide()
    },

    toggle(visibility, tabIndex) {
      this.$refs.panel.toggle(visibility)
      this.selectTab(tabIndex)
    },

    panelVisible() {
      return this.$refs.panel.getVisibility()
    },

    selectTab(index) {
      if (this.$refs.tabs) {
        this.$refs.tabs.selectTab(index)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
